import TarjetasDashboard from './TarjetasDashboard';
import React from 'react';
import { connect } from 'react-redux';
import FiltroDashboard from './Components/FiltroDashboard';
import {
  fetchFiltroDashboard,
  setFiltroDashboard,
  fetchDashboardCoreTotalizadores,
  fetchResumenEstadosDeOrdenes,
  fetchTopProductosSeller,
  fetchTopCategorias,
  fetchTopTipoPublicaciones
} from '../../../actions/dashboardActions';
import { setFiltroOrdenes } from '../../../actions/ordenesActions';
import { setFiltroPublicacion } from '../../../actions/publicacionesActions';
import { limpiarFiltros } from '../../../actions/generalActios';
import { formatoDecimal } from '../../../utilities/formatoNumeros';
import { filtroUnDia, filtroUnaSemana } from '../../../utilities/fechasFiltro';
import BigSpinner from "../../General/BigSpinner";
import './Styles/Dashboard.css';
import BtnToggleFilter from "../../General/Filter/BtnToggleFilter";
import { withNavigation } from "../../General/withNavigation";

// Charts
import { Pie, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement, Tooltip, Legend,
  CategoryScale, LinearScale, BarElement, Title
} from 'chart.js';

// Helpers puros (extraídos)
import {
  buildCategoriasBarData,
  getBarOptions,
  buildPieData,
  getTotalOrdenes,
  hasChartData,
  normalizeTarjetasData
} from './DashboardHelper';
import { getTopSellers, getTipoPublicaciones } from '../../../api/axios';

// Registrar TODO lo que usan Pie y Bar
ChartJS.register(
  ArcElement, Tooltip, Legend,
  CategoryScale, LinearScale, BarElement, Title
);

const fechaFiltro = filtroUnDia();

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //showFilter: false,
      filterOptions: undefined,
      mostrarUnidades: false, // toggle para el Bar de categorías
      topSellers: [],
      tipoPublicaciones: [],
      tabProductos: 0, // estado para tabs de Top Productos
    };
  }

  componentDidMount() {
    const { userType } = this.props || {};

    // Carga inicial (sin filtro explícito o con filtro default)
    if (userType && !userType.isSoloLectura) {
      this.busqueda();

      // Legacy calls for Dropdowns/Lists (Only Admin might need TopSellers list?)
      // Mantengo esto si es necesario para listas, pero los charts vendran de Redux
      // Legacy calls for Dropdowns/Lists (Only Admin might need TopSellers list?)
      // Mantengo esto si es necesario para listas, pero los charts vendran de Redux
      if (userType.isAdminMod || this.props.tipoUsuario == 1 || this.props.tipoUsuario == 2) {
        getTopSellers().then(topSellers => {
          this.setState({ topSellers });
        }).catch(() => { });

        getTipoPublicaciones().then(tipoPublicaciones => {
          this.setState({ tipoPublicaciones });
        }).catch(() => { });
      }
    }
  }

  busqueda = (filterOverride) => {
    const { userType, idSeller: idSellerProp, filtroDashboard } = this.props;
    const filtro = { ...(filterOverride || this.state.filterOptions || filtroDashboard || {}) };

    // Default dates logic if needed
    // Default dates logic if needed
    if (!filtro.fechaDesde) {
      const today = new Date();
      // Get YYYY-MM-DD in local time
      const formattedDate = today.toLocaleDateString('en-CA');

      filtro.fechaDesde = formattedDate;
      filtro.fechaHasta = formattedDate;
      filtro.verMes = false;
    }

    // Determine target IdSeller
    let targetIdSeller = null;

    if (this.props.tipoUsuario == 1 || this.props.tipoUsuario == 2) {
      // Admins (1 or 2) use the filter selection (or null for all)
      targetIdSeller = filtro.idSeller || filtro.seller || null;
    } else {
      // Everyone else (3, 4, etc) filtered by their ID
      targetIdSeller = idSellerProp;
    }

    // Prepare params object
    const params = {
      fechaDesde: filtro.fechaDesde,
      fechaHasta: filtro.fechaHasta,
      verMes: filtro.verMes,
      idSeller: targetIdSeller
    };

    // Call Actions
    this.setState({ filterOptions: filtro });

    // 1. Totalizadores (Cards)
    this.props.fetchDashboardCoreTotalizadores(params);

    // 2. Charts & Tables
    this.props.fetchResumenEstadosDeOrdenes(params);
    this.props.fetchTopCategorias(params);
    this.props.fetchTopTipoPublicaciones(params);
    this.props.fetchTopProductosSeller(params);
  };

  chargeFilterOptions = (options) => {
    this.props.setFiltroDashboard(options);
    this.setState({ filterOptions: options }, () => {
      this.busqueda(options);
    });
  };

  handleSelectTopProduct = (item) => {
    // tomar valores con nombres posibles
    const codigoProducto = item?.codigoProducto ?? item?.CodigoProducto ?? "";
    // si el item no lo trae, uso el idSeller del filtro o del estado global
    const idSeller = item?.idSeller ?? item?.IdSeller ?? this.props.filtroDashboard?.idSeller ?? this.props.idSeller;

    if (!codigoProducto) {
      return;
    }

    this.props.setFiltroPublicacion({
      skuMarket: codigoProducto,
      fechaPubDesde: null,
      fechaPubHasta: null,
      idPublicacion: null,
      idSeller: null
    });

    this.props.navigate('/Publicaciones', { state: { shouldFetch: true } });
  };

  toggleMostrarUnidades = (e) => {
    this.setState({ mostrarUnidades: e.target.checked });
  };

  handleChartClick = (event, elements) => {
    if (!elements || elements.length === 0) return;

    const index = elements[0].index;
    // index 0: Facturadas (id: 2)
    // index 1: Pendiente Facturar (id: 1)
    // index 2: Anuladas (id: 5)

    let idEstado = null;
    let labelEstado = "";

    switch (index) {
      case 0: // Facturadas
        idEstado = 2;
        labelEstado = "FACTURADO";
        break;
      case 1: // Pendiente
        idEstado = 1;
        labelEstado = "PENDIENTE";
        break;
      case 2: // Anuladas
        idEstado = 5;
        labelEstado = "ANULADO";
        break;
      default:
        return;
    }

    const { filtroDashboard, userType, idSeller } = this.props;

    // Determine correct idSeller: enforce proper ID for Sellers
    let targetIdSeller = "";
    // If Admin/Category (1 or 2), use the one from filter; otherwise generic prop
    if (this.props.tipoUsuario == 1 || this.props.tipoUsuario == 2) {
      targetIdSeller = filtroDashboard?.idSeller || "";
    } else {
      targetIdSeller = idSeller;
    }

    let fechaDesde = filtroDashboard?.fechaDesde;
    let fechaHasta = filtroDashboard?.fechaHasta;

    if (!fechaDesde) {
      const defaultFechas = filtroUnaSemana();
      fechaDesde = defaultFechas.desde;
      fechaHasta = defaultFechas.hasta;
    }

    // Ensure we send empty strings instead of nulls to prevent ListOrdenes from applying default dates
    const filterToSet = {
      fechaDesde: fechaDesde,
      fechaHasta: fechaHasta,
      idSeller: targetIdSeller,
      idEstado: idEstado,
      estado: { value: idEstado, label: labelEstado },
      numeroPagina: 1
    };

    // Signal that we have an active filter for Ordenes
    this.props.limpiarFiltros({ ordenes: false, publicaciones: true, sellers: true });
    this.props.setFiltroOrdenes(filterToSet);
    this.props.navigate('/Ordenes');
  };

  render() {
    const {
      isLoading, userType, filtroDashboard,
      tarjetasDashboardDto, resumenEstadosOrden,
      topProductos, topCategorias, topTipoPublicaciones
    } = this.props;

    if (userType?.isSoloLectura || userType?.isProveedor) return null;

    const pieData = buildPieData(resumenEstadosOrden);
    const totalOrdenes = getTotalOrdenes(resumenEstadosOrden);
    const modoCategorias = this.state.mostrarUnidades ? 'unidades' : 'monto';

    // Visibility Logic: Admin OR Seller (Types 3/4)
    // STRICT CHECK: Type 1 (Category) or Type 2 (AdminMod) are fully authorized.
    // Sellers (3, 4) are also authorized but limited.
    const isAuthorized = (this.props.tipoUsuario == 1 || this.props.tipoUsuario == 2) || userType?.isSeller || userType?.isSellerAdmin;

    return (
      <div className="container">
        <div>
          <FiltroDashboard
            filtro={this.props.emptyFiltro.dashboard === false ? filtroDashboard : ""}
            chargeFilterOptions={this.chargeFilterOptions}
          />
        </div>

        {isLoading ? (
          <BigSpinner />
        ) : (
          <>
            {isAuthorized && (
              <div className="row">
                <div className="col-12 mb-4">
                  <TarjetasDashboard
                    data={tarjetasDashboardDto}
                    topProductos={topProductos}
                    onSelectProduct={this.handleSelectTopProduct}
                    userType={userType}
                    currentUserType={this.props.tipoUsuario}
                    tabProductos={this.state.tabProductos}
                    setTabProductos={tab => this.setState({ tabProductos: tab })}
                    topSellers={this.state.topSellers}
                    // For TopTipoPublicaciones chart, we might need to update TarjetasDashboard to accept the Redux prop
                    // Passing the Redux prop 'topTipoPublicaciones' as 'tipoPublicaciones' prop to override or complement
                    tipoPublicaciones={topTipoPublicaciones || this.state.tipoPublicaciones}
                  />
                </div>
              </div>
            )}

            {isAuthorized && (
              <div className="row">
                {/* Estado de Ordenes */}
                <div className="col-12 col-lg-6 mb-4">
                  <div className="dashboard-container p-3 rounded shadow-sm d-flex flex-column h-100">
                    <div className="d-flex align-items-center mb-3">
                      <div className="icon-circle mr-2 bg-light-danger text-danger">
                        <i className="mdi mdi-chart-pie" style={{ fontSize: '1.2rem' }}></i>
                      </div>
                      <h5 className="m-0 text-dark font-weight-bold">Estado de Órdenes</h5>
                    </div>
                    <div className="flex-grow-1" style={{ position: 'relative', height: '300px' }}>
                      {hasChartData(pieData) ? (
                        <Pie
                          data={pieData}
                          options={{
                            onClick: this.handleChartClick,
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                              legend: {
                                position: 'right',
                                labels: {
                                  usePointStyle: true,
                                  boxWidth: 8
                                }
                              },
                              tooltip: {
                                callbacks: {
                                  label: (ctx) => {
                                    const v = Number(ctx.raw ?? 0);
                                    const pct = totalOrdenes
                                      ? ((v / totalOrdenes) * 100).toFixed(1)
                                      : '0.0';
                                    return `${ctx.label}: ${v} (${pct}%)`;
                                  },
                                },
                              }
                            }
                          }}
                        />
                      ) : (
                        <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                          Sin datos
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Top Categorías */}
                <div className="col-12 col-lg-6 mb-4">
                  <div className="dashboard-container p-3 rounded shadow-sm d-flex flex-column h-100">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <div className="icon-circle mr-2 bg-light-primary text-primary">
                          <i className="mdi mdi-chart-bar" style={{ fontSize: '1.2rem' }}></i>
                        </div>
                        <h5 className="m-0 text-dark font-weight-bold">Top Categorías</h5>
                      </div>
                      <label className="mb-0" style={{ userSelect: 'none', cursor: 'pointer', fontSize: '0.9rem' }}>
                        <input
                          type="checkbox"
                          className="mr-1"
                          checked={this.state.mostrarUnidades}
                          onChange={this.toggleMostrarUnidades}
                          style={{ marginRight: 6 }}
                        />
                        Unidades
                      </label>
                    </div>

                    <div className="flex-grow-1" style={{ position: 'relative', height: '300px' }}>
                      {Array.isArray(topCategorias) && topCategorias.length ? (
                        <Bar
                          data={buildCategoriasBarData(topCategorias, modoCategorias)}
                          options={{
                            ...getBarOptions(modoCategorias),
                            maintainAspectRatio: false
                          }}
                        />
                      ) : (
                        <div className="d-flex align-items-center justify-content-center h-100 text-muted">
                          Sin datos
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  idSeller: state.general.idSeller,
  ventas: state.dashboard.totalizadores?.ventas,
  ordenes: state.dashboard.totalizadores?.ordenes,
  publicaciones: state.dashboard.totalizadores?.publicaciones,
  isLoading: state.dashboard.isLoading,
  filtroDashboard: state.dashboard.filtro,
  emptyFiltro: state.general.limpiar,
  userType: state.general.userType,
  tipoUsuario: state.general.tipoUsuario,
  tarjetasDashboardDto:
    state.dashboard.core?.tarjetasDashboardDto ??
    state.dashboard.tarjetasDashboardDto ??
    state.dashboard.totalizadores ?? // Fallback for Sellers who use LandingController
    state.dashboard.core?.tarjetaDashboardDtoHelperResponse,
  resumenEstadosOrden:
    state.dashboard?.resumenEstados?.resumenEstadosOrden ??
    state.dashboard?.resumenEstadosOrden ??
    state.dashboard?.resumenEstados ??
    null,
  topProductos: state.dashboard.topProductos || [],
  topCategorias: state.dashboard.topCategorias || [],
  topTipoPublicaciones: state.dashboard.topTipoPublicaciones || [],
});

export default withNavigation(connect(mapStateToProps, {
  setFiltroDashboard,
  limpiarFiltros,
  fetchDashboardCoreTotalizadores,
  setFiltroPublicacion,
  fetchResumenEstadosDeOrdenes,
  fetchTopProductosSeller,
  fetchTopCategorias,
  fetchTopTipoPublicaciones,
  setFiltroOrdenes
})(Dashboard));
